export enum FileFromType {
  INVALID = "INVALID",
  FROM_DOCTOR = "FROM_DOCTOR",
  FROM_LAB = "FROM_LAB",
}
